import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";

import * as fromTeacherMetrics from "./teacher-metrics.reducer";
import * as fromCourses from "./teacher-classes.reducer";
import * as fromActiveLanguages from "./active-languages.reducer";
import * as fromActiveSubjects from "./active-subjects.reducer";
import * as fromActiveEditions from "./active-editions.reducer";
import * as fromStudents from "./students.reducer";
import * as fromSchools from "./schools.reducer";
import * as fromAssignments from "./assignments.reducer";
import * as fromAssignmentsStudents from "./assignments-students.reducer";
import * as fromGrades from "./grades.reducer";

// this is the type for our teacher-classes.module
// this creates the structure for our state tree
export interface CoursesState {
    teacherMetrics: fromTeacherMetrics.TeacherMetricsState;
    courses: fromCourses.CoursesListState;
    activeLanguages: fromActiveLanguages.ActiveLanguagesState;
    students: fromStudents.StudentsListState;
    schools: fromSchools.SchoolsListState;
    assignments: fromAssignments.AssignmentsListState;
    assignmentsStudents: fromAssignmentsStudents.AssignmentsStudentsListState;
    grades: fromGrades.GradesState;
    activeSubjects: fromActiveSubjects.ActiveSubjectsState;
    activeEditions: fromActiveEditions.ActiveEditionsState;
}

// register the reducers
// a slice of state is managed by a reducer function
// ** Remember a reducer is a pure function
// this can be type check with ActionReducerMap as type CoursesState
export const reducers: ActionReducerMap<CoursesState> = {
    teacherMetrics: fromTeacherMetrics.reducer,
    courses: fromCourses.reducer,
    activeLanguages: fromActiveLanguages.reducer,
    students: fromStudents.reducer,
    schools: fromSchools.reducer,
    assignments: fromAssignments.reducer,
    assignmentsStudents: fromAssignmentsStudents.reducer,
    grades: fromGrades.reducer,
    activeSubjects: fromActiveSubjects.reducer,
    activeEditions: fromActiveEditions.reducer,
};

// This const creates the base level of our state object
// A reference to our Courses State
// and will hold a selector for the entire lazy-loaded module
export const getCoursesModuleState =
    createFeatureSelector<CoursesState>("coursesModule");

// This const creates the base level of our state object
// A reference to our AssignmentsState
// and will hold a selector for the entire lazy-loaded module
export const getAssignmentsModuleState =
    createFeatureSelector<CoursesState>("evaluateModule");
